import { getAccessToken } from '../auth/tokenService';

const ADMIN_API_BASE = process.env.REACT_APP_API_URL
  ? `${process.env.REACT_APP_API_URL}/admin`
  : '/api/admin';

function getHeaders() {
  const token = getAccessToken();
  return {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
  };
}

/**
 * List all admin users
 */
export async function listAdmins() {
  const response = await fetch(`${ADMIN_API_BASE}/admins`, {
    method: 'GET',
    headers: getHeaders(),
  });

  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.detail || 'Failed to list admins');
  }

  return response.json();
}

/**
 * Create a new admin
 */
export async function createAdmin(email, fullName) {
  const response = await fetch(`${ADMIN_API_BASE}/admins`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify({ email, full_name: fullName }),
  });

  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.detail || 'Failed to create admin');
  }

  return response.json();
}

/**
 * Update an admin
 */
export async function updateAdmin(email, data) {
  const response = await fetch(`${ADMIN_API_BASE}/admins/${encodeURIComponent(email)}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.detail || 'Failed to update admin');
  }

  return response.json();
}

/**
 * Delete an admin
 */
export async function deleteAdmin(email) {
  const response = await fetch(`${ADMIN_API_BASE}/admins/${encodeURIComponent(email)}`, {
    method: 'DELETE',
    headers: getHeaders(),
  });

  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.detail || 'Failed to delete admin');
  }

  return response.json();
}
